import {Routes, Route, useSearchParams, useLocation} from 'react-router-dom';
import { AuthContextProvider } from './store/AuthContext';
import { HeaderContextProvider } from './store/HeaderContext';
import NativeInterface from "services/NativeInterface"

import HeaderMain from "./components/header/HeaderMain"
import FooterMobile from "./components/header/FooterMobile"

import {SidePanel} from './components/SidePanel';
import MainPage from "./pages/main/MainPage";
import InfoPage from "./pages/InfoPage";
import MapPage from "./pages/MapPage";
import DimensionPage from "./pages/dimension/DimensionPage";
import SavedPage from "./pages/SavedPage";
import OwnDimensionsPage from "./pages/OwnDimensionsPage";
import AccountPage from "./pages/AccountPage";
import SettingsPage from "./pages/SettingsPage";
import AnalyticsPage from "./pages/analytics/AnalyticsPage";
import EditDimensionPage from "./pages/edit_dimension/EditDimensionPage";
import EditLocationPage from "./pages/edit_location/EditLocationPage";
import NativeAppPage from "./pages/NativeAppPage";
import { LanguageProvider } from './pages/dimension/LanguageContext';
import Onboarding,{ useOnboardingState }  from "./pages/Onboarding";

import "./App.css"

function App() {
    const [onboardingCompleted, completeOnboarding] = useOnboardingState();
    const location = useLocation()

    return (
        <>
            <AuthContextProvider>
                <LanguageProvider>
                    {!onboardingCompleted && NativeInterface.isPWA() ? (
                        <Onboarding onComplete={completeOnboarding} />
                    ) : (
                        <HeaderContextProvider>
                            <div className='main-container'>
                                {!NativeInterface.isPWA() && (
                                    <div className="large-screen-only">
                                        <HeaderMain />
                                    </div>
                                )}
                                <div className="body-container">
                                    {!NativeInterface.isPWA() && (
                                        <div className="side-container large-screen-only">
                                            <SidePanel/>
                                        </div>
                                    )}
                                    <div className="content-container">
                                        <Routes>
                                            <Route path='/' element={<MainPage/>} />
                                            <Route path='/info' element={<InfoPage/>} />
                                            <Route path='/map' element={<MapPage/>} />
                                            <Route path='/dimension' element={<DimensionPage/>} />
                                            <Route path='/saved' element={<SavedPage/>} />
                                            <Route path='/own-dimensions' element={<OwnDimensionsPage/>} />
                                            <Route path='/account' element={<AccountPage/>} />
                                            <Route path='/settings' element={<SettingsPage/>} />
                                            <Route path='/analytics' element={<AnalyticsPage/>} />
                                            <Route path='/edit-dimension' element={<EditDimensionPage/>} />
                                            <Route path='/edit-location' element={<EditLocationPage/>} />
                                            <Route path='/app' element={<NativeAppPage/>}/>
                                        </Routes>
                                    </div>
                                </div>
                            </div>

                            {!NativeInterface.isPWA() && location.pathname !== '/dimension' && (
                                <div className="small-screen-only">
                                    <FooterMobile />
                                </div>
                            )}
                            {NativeInterface.isPWA() && location.pathname !== '/dimension' && (
                                <FooterMobile />
                            )}

                        </HeaderContextProvider>
                    )}
                </LanguageProvider>
            </AuthContextProvider>
        </>
    );
}


export default App;
